export const ArticleContentType = {
  Html: 1,
  Pdf: 2,
}
